import { BarChart3 } from 'lucide-react';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { z } from 'zod';
import { GlobalTopNav } from '@/components/GlobalTopNav';
import { LeadKPICards } from '@/components/LeadKPICards';
import { LeadSidebar } from '@/components/LeadSidebar';
import { Button } from '@/components/ui/button';
export function LeadMain() {
  const [showKPIs, setShowKPIs] = useState<boolean>(() => {
    const rawValue = localStorage.getItem('showKPIs');
    if (rawValue === null) return true;
    const result = z.enum(['true', 'false']).safeParse(rawValue);
    if (!result.success) {
      console.error(result.error);
      localStorage.removeItem('showKPIs');
      return true;
    }
    return result.data === 'true';
  });
  const toggleShowKPIs = () => {
    setShowKPIs((prev) => {
      const next = !prev;
      localStorage.setItem('showKPIs', next ? 'true' : 'false');
      return next;
    });
  };
  return (
    <div className="h-screen flex flex-col bg-white">
      <GlobalTopNav />
      <div className="flex flex-1 overflow-hidden">
        <LeadSidebar />
        <div className="flex-1 overflow-auto bg-[#f5f5f5] overscroll-contain">
          <div className="p-6">
            <div className="flex items-center justify-between mb-6">
              <div>
                <p className="text-xs text-gray-600 mb-1">
                  Track and manage maintenance leads through their lifecycle
                </p>
              </div>
              <Button
                variant="outline"
                size="sm"
                className="flex items-center gap-2"
                type="button"
                onClick={toggleShowKPIs}
              >
                <BarChart3 className="w-4 h-4" />
                {showKPIs ? 'Hide KPIs' : 'Show KPIs'}
              </Button>
            </div>
            {showKPIs && <LeadKPICards />}
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
